/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import ProcedureMonitors from './procedure-monitors';
import ProcedureMonitorsDetail from './procedure-monitors-detail';
import ProcedureMonitorsUpdate from './procedure-monitors-update';
import ProcedureMonitorsDeleteDialog from './procedure-monitors-delete-dialog';

const ProcedureMonitorsRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<ProcedureMonitors />} />
    <Route path="new" element={<ProcedureMonitorsUpdate />} />
    <Route path=":id">
      <Route index element={<ProcedureMonitorsDetail />} />
      <Route path="edit" element={<ProcedureMonitorsUpdate />} />
      <Route path="delete" element={<ProcedureMonitorsDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default ProcedureMonitorsRoutes;
